import React, { FC, useState } from 'react';
import { IconButton, InputAdornment, TextField, TextFieldProps, Tooltip } from '@mui/material';

import { EyeIcon, EyeSlashIcon } from 'src/shared/components/icons';
import { TranslationFunction, useTranslate } from 'src/shared/providers';
import './PasswordTextField.styles.scss';

export type StrengthIndicatorType = 'strong' | 'medium' | 'weak';

interface Props {
  strengthIndicatorType?: StrengthIndicatorType;
  className?: string;
}

export const PasswordTextField: FC<Props & TextFieldProps> = ({ className = '', strengthIndicatorType, ...props }) => {
  const { t } = useTranslate();
  const [passwordType, setPasswordType] = useState<'password' | 'text'>('password');
  const strengthIndicatorText = getStrengthIndicatorText(strengthIndicatorType, t);

  return (
    <Tooltip
      classes={{
        tooltip: `password-tooltip ${strengthIndicatorType}`,
        arrow: `password-tooltip-arrow ${strengthIndicatorType}`,
      }}
      arrow
      open={!!strengthIndicatorType}
      placement="right"
      title={strengthIndicatorText || false}
    >
      <TextField
        {...props}
        className={`${className} ${strengthIndicatorType ? `strength-indicator ${strengthIndicatorType}` : ''}`}
        type={passwordType}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <IconButton onClick={() => setPasswordType(passwordType === 'password' ? 'text' : 'password')}>
                {passwordType === 'password' ? <EyeSlashIcon /> : <EyeIcon />}
              </IconButton>
            </InputAdornment>
          ),
        }}
      />
    </Tooltip>
  );
};

const getStrengthIndicatorText = (
  type: StrengthIndicatorType | undefined,
  t: TranslationFunction,
): string | undefined => {
  switch (type) {
    case 'strong':
      return t('global.strong');
    case 'medium':
      return t('global.medium');
    case 'weak':
      return t('global.weak');
    default:
      return;
  }
};
